import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const grid = styled('div')`
  position: relative;
`;

// header
const header = styled('div')`
  padding: 32px 46px 28px 38px;
`;

const title = styled('div')`
  font-size: 3.2rem;
  font-weight: 500;
  color: var(--black);
  line-height: 1.1875;
`;

// footer
const footer = styled('div')`
  padding: 20px;
  font-size: var(--ph-text-sm);
  color: var(--ph-gray-500);
`;

// table
const table = styled('div')`
  border-top: solid 1px rgba(var(--ph-gray-500), 0.2);
  border-bottom: solid 1px rgba(var(--ph-gray-500), 0.2);
  min-height: 100px;

  &.withColumns {
    border-top: 0;
  }

  &.noborder {
    border: 0;
  }

  label {
    background-color: var(--ph-light-blue-500);
    color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    padding: 3px;
    font-size: var(--ph-text-xs);
  }

  span {
    max-width: 75%;
    text-overflow: ellipsis;
    display: inline-block;
  }
`;

const tableItems = styled('div')`
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0 20px;
`;

const row = styled('div')`
  padding: 18px 20px 19px;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  &:hover {
    border: solid 1px var(--ph-gray-50);
    background-color: var(--white);
  }
`;

const column = styled('div')`
  opacity: 0.7;
  font-size: 1.4rem;
  line-height: 1.43;
  color: var(--black);
  flex: 1;

  &.hidden {
    display: none;
  }
`;

const headerColumns = styled('div')`
  padding: 7px 20px 8px;
  border-top: solid 1px rgba(var(--ph-gray-500), 0.2);
  border-bottom: solid 1px rgba(var(--ph-gray-500), 0.2);
`;

const headerRow = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 0 20px;
`;

const headerColumn = styled('div')`
  flex: 1;
  font-size: var(--ph-text-sm);
  line-height: 1.54;
  color: var(--black);
  padding: 0 10px;
`;

const SettingsButton = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;

  &:hover {
    background-color: rgba(var(--black), 0.2);
  }
`;

const SettingsButtonIcon = styled(Svg)`
  width: 14px;

  * {
    fill: var(--white) !important;
  }
`;

const CellWithDeletedStatus = styled('span')`
  &.deleted {
    opacity: 0.5;
    text-decoration: line-through;
  }

  &:not(:last-child)::after {
    content: ',';
    margin-right: 5px;
  }
`;

export default {
  Grid: grid,
  Title: title,
  Header: header,
  Footer: footer,
  Table: table,
  TableItems: tableItems,
  Row: row,
  Column: column,
  HeaderRow: headerRow,
  HeaderColumn: headerColumn,
  HeaderColumns: headerColumns,
  SettingsButton,
  SettingsButtonIcon,
  CellWithDeletedStatus,
};
